import { CloseOutlined } from "@ant-design/icons";
import { Image } from "antd";
import { Mask } from "antd-mobile";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { NoMoreReminder } from "../../../../components";
import { useDailyCheck } from "../../../../context/DailyCheckContext";
import { useLogin } from "../../../../context/LoginContext";
import localStorageKey from "../../../../enumerations/localStorageKey";
import { envChangeType, langMap } from "../../../../plugins/utils";
import { usePopupContext } from "../../context/PopupContext";
import { popupSortingEnum } from "../../enumeration/popupSortingEnum";
import { setTomorrowCheck, tomorrowCheck } from "../../utils";
import styles from "./style.module.scss";

const DailyCheckPopup = () => {
  const { t } = useTranslation();
  const { state } = useLocation();
  const navigate = useNavigate();
  const { data: dailyCheckData, lang } = useDailyCheck();
  const { sorting, setNextSorting } = usePopupContext();
  const { userInfo, checkIfLogin } = useLogin();
  const tomorrowCheckTime = JSON.parse(localStorage.getItem(localStorageKey.TOMORROW_CHECK_TIME));
  const [visible, setVisible] = useState(false);
  const [checked, setChecked] = useState(false);
  const timeName = "dailyCheckTime";

  const closeModal = () => {
    setTomorrowCheck(tomorrowCheckTime, checked, userInfo, timeName);
    setNextSorting();
    setVisible(false);
  };

  useEffect(() => {
    if (!dailyCheckData || !userInfo || popupSortingEnum[timeName].sorting !== sorting) return;
    if (
      Object.keys(dailyCheckData).length > 0 &&
      dailyCheckData.current_signin_day &&
      !state?.goBet
    ) {
      tomorrowCheck(tomorrowCheckTime, setVisible, userInfo, timeName, "", setNextSorting);
    } else {
      setNextSorting();
    }
  }, [dailyCheckData, userInfo, sorting]);

  return (
    <>
      <Mask visible={visible} opacity="thick" onMaskClick={closeModal}>
        <div className={styles.container}>
          <div className={styles.header}>
            <CloseOutlined className={styles.close} onClick={closeModal} />
          </div>
          <div className={styles.imgContainer}>
            <Image
              src={`/images/dailyCheck/${envChangeType("REACT_APP_PRODUCTION_NAME_DEV")}/${langMap(["zh", "en", "vi"])}/daily_check.png`}
              fallback={`/images/dailyCheck/${langMap(["zh", "en", "bn"])}/daily_check.png`}
              alt="daily_check"
              className={styles.img}
              preview={false}
            />
          </div>
          <div className={styles.btnContainer}>
            <Image
              src={`/images/dailyCheck/${envChangeType("REACT_APP_PRODUCTION_NAME_DEV")}/${langMap(["en", "zh"])}/check_btn.png`}
              fallback={`/images/dailyCheck/${langMap(["en", "zh", "bn"])}/check_btn.png`}
              alt="check_btn"
              className={styles.checkBtnImg}
              onClick={() => {
                if (!checkIfLogin()) return;
                closeModal();
                navigate(`/dailyCheck`);
              }}
              preview={false}
            />
          </div>
          <NoMoreReminder checked={checked} setChecked={setChecked} />
        </div>
      </Mask>
    </>
  );
};

export default DailyCheckPopup;
